var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "75.000000pt",
    height: "75.000000pt",
    viewBox: "0 0 75.000000 75.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,75.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268 675 c-132 -48 -211 -163 -212 -306 -1 -68 3 -83 34 -145 61 -119 167 -180 303 -172 282 14 406 354 202 552 -59 58 -133 86 -223 85 -37 0 -84 -7 -104 -14z m228 -25 c58 -25 121 -85 152 -144 23 -44 27 -63 27 -136 0 -73 -4 -92 -27 -136 -116 -221 -430 -221 -546 0 -23 44 -27 63 -27 136 0 73 4 92 27 136 26 50 84 111 130 135 73 40 185 44 264 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 531 c-106 -65 -32 -234 88 -200 75 20 109 103 69 167 -34 53 -100 67 -157 33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 300 c-69 -12 -129 -59 -146 -113 -13 -40 93 -97 181 -97 88 0 194 57 181 97 -24 76 -125 129 -216 113z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePic);
export default __webpack_public_path__ + "static/media/profilePic.7b8ab1c9cb68ac8abe8c8859acd271ce.svg";
export { ForwardRef as ReactComponent };